import React from 'react'
import Layout from '../../components/Layout'
import Intro from './intro'
import WebdesignStrategies from './WebdesignStrategies';
import WebStrategy from "./WebStrategy";


const Home = () => {
  return (
    <Layout>
      <div>
        <Intro/>
        <WebStrategy />
        <WebdesignStrategies />
      </div>
    </Layout>
  )
}

export default Home